/**
 * Salesforce Inspector Reloaded
 *
 * Exposes its UI pages (`inspect.html`, `popup.html`, `data-export.html`, …) as static
 * web-accessible resources, but scoped to Salesforce origins only
 * (`https://*.salesforce.com/*`, `*.force.com`, `*.lightning.force.com`, and ~15 more).
 * So it is detectable — but only from a Salesforce page, which is exactly where this
 * developer tool is used.
 *
 * From any other origin the resources are unreachable, so a negative there is
 * inconclusive rather than a true negative.
 *
 * Manifest verified against version 1.271.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'hpijlohoihegkfehhibggnkbjhoemldh';

export const salesforceInspector: ExtensionDefinition = {
  id: ID,
  name: 'Salesforce Inspector Reloaded',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 500_000,
  requiredOrigin: 'https://login.salesforce.com',
  notes:
    'UI pages are static WAR but scoped to Salesforce origins, so only a Salesforce ' +
    'page can detect it — the natural place this tool runs.',
  signals: [
    {
      id: 'war-inspect-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch inspect.html — the extension\'s record inspector page, exposed to ' +
        'Salesforce origins. Distinctive to this tool.',
      weight: 1,
      run: () => probeFetch(ID, 'inspect.html'),
    },
    {
      id: 'war-data-export-html',
      kind: 'web-accessible-resource',
      description: 'Fetch data-export.html — a second origin-scoped UI page.',
      weight: 0.5,
      run: () => probeFetch(ID, 'data-export.html'),
    },
  ],
};
